import { supabase } from './supabase'

/**
 * Returns a JWT suitable for calling Supabase Edge Functions.
 * Tries refresh first so the token is not expired when the request lands.
 */
export async function getFreshAccessToken(): Promise<string> {
  const { data, error } = await supabase.auth.refreshSession()
  const refreshed = data.session?.access_token
  if (refreshed) return refreshed

  if (error) {
    const { data: { session } } = await supabase.auth.getSession()
    if (session?.access_token) return session.access_token
    throw error
  }

  const { data: { session } } = await supabase.auth.getSession()
  if (!session?.access_token) throw new Error('Not authenticated')
  return session.access_token
}
